import React from 'react'
import { DateTime } from 'luxon'

interface InvoiceCountProps {
	totalInvoices: number
	searchFilter?: string
	group?: string
	client?: string
	director?: string
	manager?: string
	invoiced?: string
	created?: string
	dateStart?: DateTime
	dateEnd?: DateTime
}

const InvoiceCount = (props: InvoiceCountProps) => {
	return (
		<span style={{ lineHeight: '42px' }}>
			{'Showing '}
			<span className="span-bold span-blue">{props.totalInvoices}</span>
			{' Invoices'}
			{props.searchFilter && ` with Invoice No. ${props.searchFilter}`}
			{props.group && (
				<>
					{', for '}
					<span className="span-bold span-blue">{props.group}</span>
					{' group'}
				</>
			)}
			{props.client && (
				<>
					{', for '}
					<span className="span-bold span-blue">{props.client}</span>
					{' client '}
				</>
			)}
			{props.director && (
				<>
					{', for partner '}
					<span className="span-bold span-blue">{props.director}</span>
				</>
			)}
			{props.manager && (
				<>
					{', managed by '}
					<span className="span-bold span-blue">{props.manager}</span>
				</>
			)}
			{props.invoiced && (
				<>
					{', invoiced by '}
					<span className="span-bold span-blue">{props.invoiced}</span>
				</>
			)}
			{props.created && (
				<>
					{', created by '}
					<span className="span-bold span-blue">{props.created}</span>
				</>
			)}
			{props.dateStart && (
				<>
					{', from '}
					<span className="span-bold span-blue">{props.dateStart.toFormat('d MMMM yyyy')}</span>
				</>
			)}
			{props.dateEnd && (
				<>
					{', to '}
					<span className="span-bold span-blue">{props.dateEnd.toFormat('d MMMM yyyy')}</span>
				</>
			)}
		</span>
	)
}

export default InvoiceCount
